/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { updateCms } from "api/services/cmsServices";
import { getCms } from "api/services/cmsServices";
import Card from "components/card";
import InputField from "components/fields/InputField";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

const HomeBanner = () => {
    const [formData, setformData] = useState({
        title: "",
        description: ""
    });
    const [error, setError] = useState("");

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        let response = await getCms("homepage_heading")
        if (response.status == 200) {
            setformData({
                ...formData,
                description: response?.data?.data?.description,
                title: response?.data?.data?.title,
            })
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        const newErrors = {};

        if (!formData.title.trim()) {
            newErrors.title = "Title is required";
        }
        if (!formData.description.trim() || formData.description == "<p><br></p>") {
            newErrors.description = "Description is required";
        }

        if (Object.keys(newErrors).length > 0) {
            setError(newErrors);
            return;
        }

        formData.type = "homepage_heading"

        try {
            let response = await updateCms(formData);

            if (response?.status == 200) {
                toast.success("Data updated successfully");
            } else {
                toast.error("Failed to update data");
            }
        } catch (error) {
            toast.error(error.response?.data?.error || "Something went wrong");
        }
    };

    return <div className="mt-5">
        <Card extra={"w-full h-full sm:overflow-auto p-6"}>
            <form>
                <InputField
                    label="Title*"
                    placeholder="Enter Title"
                    id="title"
                    type="text"
                    value={formData?.title}
                    onChangeFun={(e) => {
                        setformData({ ...formData, title: e.target.value });
                        setError({ ...error, title: "" });
                    }}
                />
                {error.title && (
                    <p className="mb-2 ml-2 text-sm text-red-500">{error.title}</p>
                )}

                <div className="mt-3">
                    <InputField
                        label="Description*"
                        placeholder="Enter Description"
                        id="description"
                        type="text"
                        value={formData?.description}
                        onChangeFun={(e) => {
                            setformData({ ...formData, description: e.target.value });
                            setError({ ...error, description: "" });
                        }}
                    />
                    {error.description && (
                        <p className="mb-2 ml-2 text-sm text-red-500">{error.description}</p>
                    )}
                </div>

                <div className="flex justify-end mt-6">
                    <button
                        onClick={(e) => handleSave(e)}
                        className="text-md rounded-md bg-brand-500 px-4 py-1.5 font-semibold text-white shadow transition hover:bg-brand-600"
                    >
                        Save
                    </button>
                </div>
            </form>
        </Card>
    </div>;
};

export default HomeBanner;
